import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { ENVIRONMENT_INITIALIZER, EnvironmentProviders, inject, Provider } from '@angular/core';
import { authInterceptor } from 'app/core/auth/auth.interceptor';
import { AuthService } from 'app/core/auth/auth.service';
import { configuracaoPendenteInterceptor } from 'app/modules/aluguel/configuracoes/configuracao-pendente.interceptor';

export const provideAuth = (): Array<Provider | EnvironmentProviders> =>
{
    return [
        provideHttpClient(withXhr(), withInterceptors([authInterceptor, configuracaoPendenteInterceptor])),
        {
            provide : ENVIRONMENT_INITIALIZER,
            useValue: () => inject(AuthService),
            multi   : true,
        },
    ];
};
